import { LIMIT } from '@constants';
import { formatDate, getCleanedUrlParams } from '@utils';
import { pick } from 'lodash-es';

export const normalizeTeams = (data) => {
  if (!data?.length > 0) {
    return [];
  }

  const transformedData = data?.map((item) => {
    return {
      id: item?.id,
      logo: item?.logo?.url || '',
      name: item?.name || '-',
      category: '-',
      status: item?.status,
      skus: '',
    };
  });

  return transformedData;
};

export const getVendorsQueryParams = (payload = {}) => {
  const customFields = [];

  if (!payload?.pageSize) {
    payload.pageSize = LIMIT;
  }
  if (!payload?.page) {
    payload.page = '1';
  }

  if (!payload.order) {
    payload.order = 'desc';
    payload.orderBy = 'createdAt';
  }

  Object.keys(payload)?.forEach((key) => {
    if (customFields.includes(key)) {
      payload[`customFields.${key}`] = payload[key];
      delete payload[key];
    }
  });

  return getCleanedUrlParams(
    pick(payload, ['page', 'pageSize', 'order', 'orderBy'])
  );
};

export const normalizeVendorData = (data) => {
  if (!data) {
    return {};
  }

  data.details = {
    id: data?.details?.id || '-',
    name: data?.details?.name,
    email: data?.details?.contact?.email || '-',
    contactObject: {
      ...data?.details?.contact,
    },
    phoneNumber: data?.details?.contact?.phoneNumber?.[0]?.phoneNumber || '-',
    status: data?.details?.status ? 'Active' : 'Inactive',
    logo: data?.details?.logo?.url || '',
    addressObject: {
      ...data?.details?.address,
      lng: data?.details?.address?.longitude,
      lat: data?.details?.address?.latitude,
    },
    address: `${data?.details?.address?.streetAddress || ''} ${
      data?.details?.address?.streetNumber || ''
    },  ${data?.details?.address?.region || ''}, ${
      data?.details?.address?.postalCode || ''
    }`,
    createdAt: data?.details?.createdAt
      ? formatDate(data?.details?.createdAt, 'dd/MM/yyyy')
      : '-',
    updatedAt: data?.details?.updatedAt
      ? formatDate(data?.details?.updatedAt, 'dd/MM/yyyy')
      : '-',
  };

  if (data?.products) {
    const productGroups = data?.products.reduce((groups, item) => {
      const id = item?.sku?.id;
      const group = groups[id] || (groups[id] = []);
      group.push(item);
      return groups;
    }, {});

    // groupItems(data?.products, 'skuId');
    data.products = Object.keys(productGroups)?.map((key, index) => {
      return {
        label: productGroups[key]?.[0]?.sku?.name || `Tab ${index}`, // ΤODO: add SKU name
        key,
        products: productGroups[key],
      };
    });
  }
  return data;
};
